import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconClose, IconBack } from "./icons";
import { FormTreeSelect } from "@lib/components";
import { MenuItem, QuickSettingsContainer, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorBodyWrapper, MenuColorLabel, MenuColorFooterWrapper, MenuStatusLabelAvailable, ButtonV2 } from "./layout.c";
import { RestaurantUtils } from '@lib/common';
import { EligibleItemsContainer } from '../../ui/restaurant/views/settings-v2';

export function getMenuTreeNodes(store: { restaurant: T.Schema.Restaurant.RestaurantSchema | null; isNewMenuSchema?: boolean }) {
    const r = store.restaurant;
    if (!r) return [];
    if (store.isNewMenuSchema && r.menus_v2?.length) {
        return (r.menus_v2 as any[]).filter((m: any) => (m.categories || []).length).map((menu: any) => ({
            value: menu.id,
            label: menu.name,
            type: 'menu',
            children: (menu.categories || []).filter((c: any) => {
                const items = (menu.items || []).filter((i: any) => i.category_id === c.id);
                return items.length;
            }).map((category: any) => ({
                value: category.id,
                label: category.name,
                type: 'category',
                children: (menu.items || []).filter((i: any) => i.category_id === category.id).map((item: any) => ({
                    value: item.id,
                    label: item.name,
                    type: 'dish',
                })),
            })),
        })).filter((n: any) => n.children?.length);
    }
    return RestaurantUtils.menu.getTreeFilter(r, () => true);
}

interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave?: (selectedIds: string[]) => void;
    title?: string;
    printerName?: string;
    printerId?: string;
    initialSelectedIds?: string[];
}

interface State {
    add_to: string[];
}

@inject("store") @observer
class MenuPrinterEligibleItemsClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            add_to: props.initialSelectedIds ?? []
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.printerId && this.props.printerId !== prevProps.printerId) {
          const r = this.injected.store.restaurant;
          const printer = r?.settings?.printers?.find((p: any) => p._id === this.props.printerId);
          if (printer) {
            const eligibleItemIds = printer.receipt.eligible_items || [];
            this.setState({ add_to: eligibleItemIds });
          }
        }
        if (this.props.initialSelectedIds && this.props.initialSelectedIds !== prevProps.initialSelectedIds) {
            this.setState({ add_to: this.props.initialSelectedIds });
        }
    }

    render() {
        const { store } = this.injected;
        const { show, onHide, onSave, title, printerName } = this.props;
        const { add_to } = this.state;
        const nodes = getMenuTreeNodes(store);

        return (
            <QuickSettingsContainer className={show ? 'active' : ''}>
                <MenuColorHeaderWrapper>
                    <MenuItem onClick={onHide}><IconBack /></MenuItem>
                    <MenuColorHeaderTitleWrapper>
                        {title || printerName || 'Eligible Items'}
                    </MenuColorHeaderTitleWrapper>
                    <MenuItem onClick={onHide}><IconClose /></MenuItem>
                </MenuColorHeaderWrapper>
                <MenuColorBodyWrapper style={{ minHeight: '50vh', overflowY: 'scroll' }}>
                    <MenuColorLabel>Select which items should be printed on this printer.</MenuColorLabel>
                    <MenuStatusLabelAvailable>Eligible Items</MenuStatusLabelAvailable>
                    <EligibleItemsContainer className='menus-v2'>
                        {nodes.length === 0 ? (
                            <p style={{ padding: 16, color: '#6B7270' }}>No menus or items yet.</p>
                        ) : (
                            <FormTreeSelect
                                id="add-to-dishes-printer"
                                selected={add_to}
                                nodes={nodes}
                                onChange={(add_to_dishes) => this.setState({ add_to: add_to_dishes })}
                            />
                        )}
                    </EligibleItemsContainer>
                </MenuColorBodyWrapper>
                <MenuColorFooterWrapper>
                    <ButtonV2 variant="default" onClick={onHide}>Cancel</ButtonV2>
                    <ButtonV2 onClick={() => onSave?.(add_to)}>Save</ButtonV2>
                </MenuColorFooterWrapper>
            </QuickSettingsContainer>
        );
    }
}
export const MenuPrinterEligibleItems = withTranslation()(MenuPrinterEligibleItemsClass);
